import React from 'react';

import { Button } from 'primereact/button';

interface Props {
  hasTasks: boolean;
  hasAnyAutoSelected: boolean;
  isDistributing?: boolean;
  onSelectAll: () => void;
  onDistributeSelected: () => void;
  onOpenHistory: () => void;
  onClose: () => void;
}

export const DistributionFooterActions: React.FC<Props> = ({
  hasTasks,
  hasAnyAutoSelected,
  isDistributing = false,
  onSelectAll,
  onDistributeSelected,
  onOpenHistory,
  onClose
}) => (
  <div
    className="flex justify-content-between align-items-center flex-wrap gap-2"
    style={{ width: '100%', marginBottom: 7 }}
  >
    <div className="flex gap-2 flex-wrap">
      <Button
        type="button"
        label="Выбрать все"
        icon="pi pi-check-square"
        severity="secondary"
        onClick={onSelectAll}
        disabled={!hasTasks || isDistributing}
      />
      <Button
        type="button"
        label="Распределить выбранные"
        icon="pi pi-share-alt"
        onClick={onDistributeSelected}
        disabled={!hasAnyAutoSelected || isDistributing}
        severity={!hasAnyAutoSelected && !isDistributing ? 'secondary' : undefined}
      />
    </div>
    <div className="flex gap-2 align-items-center">
      <Button
        type="button"
        style={{ width: 40 }}
        icon="pi pi-chart-line"
        onClick={onOpenHistory}
        disabled={isDistributing}
        tooltip="Журнал автоматических распределений"
        tooltipOptions={{ position: 'top' }}
      />
      <Button
        type="button"
        label="Закрыть"
        icon="pi pi-times"
        className="p-button-secondary"
        onClick={onClose}
        disabled={isDistributing}
      />
    </div>
  </div>
);
